import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {ORGANISER_DASHBOARD} from "src/app/app-routing.module";
import {RaceSettings} from "@model";
import {RaceSettingsService} from "@services";

export const RaceSettingsResolver: ResolveFn<Observable<RaceSettings | null> |
  Promise<RaceSettings | null> | RaceSettings | null> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   applicationFromSettingsService: RaceSettingsService = inject(RaceSettingsService),
   router: Router = inject(Router)): Observable<RaceSettings | null> |
    Promise<RaceSettings | null> | RaceSettings | null => {
    let raceId = route.queryParams["raceId"];
    if (!raceId) {
      router.navigate([ORGANISER_DASHBOARD]);
      return EMPTY;
    } else {
      return applicationFromSettingsService.fetchRaceSettings(
        +raceId, true)
        .pipe(
          take(1),
          mergeMap((res: RaceSettings | null) => {
            return of(res);
          })
        );
    }
  }
